import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstLx6: [],
		lx6: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getLx6(state) {
			return state.lx6
		},
		getLx6perfil(state) {
			return state.lx6.lx6perfil
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, lx6) {
			state.lx6 = lx6
			if (lx6)
				state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lx6 = null
		},
		setParamsDataTable(state, payload) {
			state.lstLx6 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLx6(state, lx6) {
			state.lx6 = lx6
		},
		setLstLx6(state, lstLx6) {
			state.lstLx6 = lstLx6
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, lx6perfil) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Price/CostProfile/Find/${lx6perfil}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("set", payload?.lx6 ?? payload)
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				});
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.post("/Price/CostProfile/Insert", getters.getLx6)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setLx6", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios.put("/Price/CostProfile/Update", getters.getLx6)
				.then(response => {
					commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
					commit("setLx6", null)
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			await this._vm.$axios.delete(`/Price/CostProfile/Delete/${getters.getLx6perfil}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/percentuais")
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, getters, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Price/CostProfile/FindList`)
				.then(response => {
					let lstLx6 = Utils.ValidateAxiosResponse(response.data);
					commit("setLstLx6", lstLx6)
					commit("setHasNext", lstLx6.length > getters.getItemsPerPage)
				}).catch(error => {
					commit("setLstLx6", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				})
			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/CostProfile/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("setParamsDataTable", payload)
					return true
				})
				.catch((error) => {
					commit("setLstLx6", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			commit("setLoading", false)
			return payload
		},
	}
}
